Object.defineProperty(exports, "__esModule", { value: true });
exports.triggerCharacters = exports.semanticTokenTypes = void 0;
function default_1() {
    return () => ({});
}
exports.default = default_1;
exports.semanticTokenTypes = [];
exports.triggerCharacters = [];
//# sourceMappingURL=empty.js.map